export const GET_MOVIES_LOADING = "GET_MOVIES_LOADING"
export const GET_MOVIES_SUCCESS = "GET_MOVIES_SUCCESS"
export const ADD_MOVIES_SUCCESS = "ADD_MOVIES_SUCCESS"
export const GET_MOVIES_ERROR = "GET_MOVIES_ERROR"
export const GET_MOVIES_UPDATE = "GET_MOVIES_UPDATE"
export const GET_MOVIE_DELETE = "GET_MOVIE_DELETE"
export const REVIEW_UPDATE="RATING_UPDATE"
export const WATCH_STATUS_TOGGLE="WATCH_STATUS_TOGGLE"
export const GET_MOVIE = "GET_MOVIE"